import React from 'react'


function NotInvited() {
  return <div className="container">
    <div className="section">
      <h1 className="title">It doesn&apos;t look like you have access to this meeting.</h1>
      <p>
        Get in touch with the Race Master and ask them to share the QR code with you.
      </p>
      <article className="message is-dark">
        <div className="message-body">
        <h2 className="subtitle">
          <strong>Are you the Race Master?</strong>
        </h2>
        <p>
          If you bought a game, click the game link in the email we sent you and enter the code to get back in.
        </p>
      </div>
      </article>
      <article className="message is-dark">
        <div className="message-body">
        <h2 className="subtitle">
          <strong>Do you have cookies disabled?</strong>
        </h2>
        <p>
          When you join a game, we drop a cookie to give you access to the game.
        </p>
        <p>If you just can&apos;t join the game at all, it may be worth checking if cookies are disabled in your browser.</p>
      </div>
      </article>
      <article className="message is-dark">
        <div className="message-body">
        <h2 className="subtitle">
          <strong>Have you been kicked out?</strong>
        </h2>
        <p>
          When you join a game, if you&apos;re doing it on your phone by scanning the QR code, <strong>try using your normal phone camera.</strong>
        </p>
        <p>
          It seems when people use special QR code apps, they keep losing access to the game.
        </p>
        <p>Use you normal camera. It will probably just work and all you problems will disappear.</p>
      </div>
      </article>
    </div>
    </div>
}

export default NotInvited
